export default __webpack_public_path__ + "static/media/lock-solid.6f1d76c8.svg";